import classnames from 'classnames';
import {
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Row, Col, Card } from 'reactstrap';

import { registrationTypeDispatch } from '@reducers/auth/AuthAction';
import useTranslation from '@shared/hooks/useTranslation';
import {
  ClinicIcon,
  LaboratoryIcon,
  PersonIcon,
} from '@shared/icons';

import './RegisterPage.scss';

const RegisterPage = () => {
  const [ onHoverType, setOnHoverType ] = useState<string | null>(null);
  const registrationType = useSelector(({ Auth }) => Auth.registrationType);
  const i18nRegister = useTranslation('registration');
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelectType = (e: any, type: string) => {
    // Prevents default behavior of anchor tag
    e.preventDefault();
    dispatch(registrationTypeDispatch(type));
    navigate(`/auth/register/${type}${location.search || ''}`);
  };

  return (
    <div className="registration-page">
      <Row>
        <Col>
          <div className="title">
            {i18nRegister.title}
          </div>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col>
          <div className="b1 description-style">
            {i18nRegister.description}
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <a
            aria-label="dentist-registration"
            role="button"
            href="#"
            onClick={(e: any) => handleSelectType(e, 'dentist')}
            className="a-tag-card-types"
          >
            <div
              onMouseEnter={() => setOnHoverType('dentist')}
              onMouseLeave={() => setOnHoverType('')}
            >
              <Card
                className={classnames('card-types', {
                  'card-selected': onHoverType === 'dentist' || registrationType === 'dentist',
                })}
              >
                <div className="mb-2">
                  <PersonIcon />
                </div>
                <div>{i18nRegister.types.dentist.label}</div>
              </Card>
            </div>
          </a>
          <div className="card-types-trial-info">
            {i18nRegister.types.dentist.priceLabel}
          </div>
        </Col>
        <Col md={4}>
          <a
            aria-label="clinic-registration"
            role="button"
            href="#"
            onClick={(e: any) => handleSelectType(e, 'dental-clinic')}
            className="a-tag-card-types"
          >
            <div
              onMouseEnter={() => setOnHoverType('dental-clinic')}
              onMouseLeave={() => setOnHoverType('')}
            >
              <Card
                className={classnames('card-types', {
                  'card-selected': onHoverType === 'dental-clinic' || registrationType === 'dental-clinic',
                })}
              >
                <div className="mb-2">
                  <ClinicIcon />
                </div>
                <div>{i18nRegister.types.clinic.label}</div>
              </Card>
            </div>
          </a>
          <div className="card-types-trial-info">
            {i18nRegister.types.clinic.trialShort}
          </div>
        </Col>
        <Col md={4}>
          <a
            aria-label="laboratory-registration"
            role="button"
            href="#"
            onClick={(e: any) => handleSelectType(e, 'laboratory')}
            className="a-tag-card-types"
          >
            <div
              onMouseEnter={() => setOnHoverType('laboratory')}
              onMouseLeave={() => setOnHoverType('')}
            >
              <Card
                className={classnames('card-types', {
                  'card-selected': onHoverType === 'laboratory' || registrationType === 'laboratory',
                })}
              >
                <div className="mb-2">
                  <LaboratoryIcon />
                </div>
                <div>{i18nRegister.types.laboratory.label}</div>
              </Card>
            </div>
          </a>
          <div className="card-types-trial-info">
            {i18nRegister.types.laboratory.priceLabel}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default RegisterPage;
